import { isValidCpf } from '@ibk/shared-utils';
import { useHasAccountQuery } from '../../../services';
export function useCpfValidation({ cpf, enabled = true }) {
    const cleanCpf = cpf.replace(/\D/g, '');
    const isCpfReady = enabled && cleanCpf.length === 11 && isValidCpf(cpf);
    const { data, isLoading, error } = useHasAccountQuery({ cpf: cleanCpf }, { skip: !isCpfReady });
    const hasValidAccount = Boolean(data?.result && Array.isArray(data.result) && data.result.length > 0);
    return {
        data,
        isLoading,
        error,
        hasValidAccount,
    };
}
